import { render, staticRenderFns } from "./updateUser.vue?vue&type=template&id=d830c068&scoped=true"
import script from "./updateUser.vue?vue&type=script&lang=js"
export * from "./updateUser.vue?vue&type=script&lang=js"
import style0 from "./updateUser.vue?vue&type=style&index=0&id=d830c068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d830c068",
  null
  
)

export default component.exports